module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0087.jpg?v=6862a358";